/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Login
 */
export interface Login {
  /**
   *
   * @type {string}
   * @memberof Login
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof Login
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof Login
   */
  password: string;
}

/**
 * Check if a given object implements the Login interface.
 */
export function instanceOfLogin(value: object): value is Login {
  if (!('password' in value) || value['password'] === undefined) return false;
  return true;
}

export function LoginFromJSON(json: any): Login {
  return LoginFromJSONTyped(json, false);
}

export function LoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): Login {
  if (json == null) {
    return json;
  }
  return {
    username: json['username'] == null ? undefined : json['username'],
    email: json['email'] == null ? undefined : json['email'],
    password: json['password'],
  };
}

export function LoginToJSON(value?: Login | null): any {
  if (value == null) {
    return value;
  }
  return {
    username: value['username'],
    email: value['email'],
    password: value['password'],
  };
}
